import { Component, OnInit } from '@angular/core';
declare var CodeMirror: any;

@Component({
  selector: 'app-learn',
  templateUrl: './learn.component.html',
  styleUrls: ['./learn.component.scss']
})
export class LearnComponent implements OnInit {
  public codeMirror: any;
  public editor: any;
  selectedTabObject: any;
  showOutput: boolean = false;
  closeQuestion: boolean = false;
  showPractice: boolean = true;
  // showLearn: boolean = false;
  public fileName: string[] = ['test.java', 'main.java', 'program.java']
  ngOnInit() {
      this.codeMirror = new CodeMirror();
      console.log(this.codeMirror);
      if(document.getElementById("editor1") != null) {
      this.editor = CodeMirror.fromTextArea(document.getElementById("editor1"), {
          lineNumbers: true,
          mode: "text/x-java",
          matchBrackets: true,
          theme: "default"
      });
    }
      this.selectedTabObject = this.fileName[0];
  }

  submit_html() {
      this.showOutput = true;
      var result = (document.getElementById("result") as HTMLInputElement)
      if (result != null) {
          this.editor.save();
          var code = (document.getElementById("editor1") as HTMLInputElement).value;
          var data_url = "data:text/html;charset=utf-8;base64," + btoa(code);
          result.src = data_url;
      }
  }

  addNewTab() {
      var length = this.fileName.length + 1;
      let newTab = 'demo' + length + '.java';
      this.fileName.push(newTab);
  }

  removeTab(index) {
      if(this.fileName.length > 1)
      this.fileName.splice(index, 1);
  }

  selectedTab(item) {
      this.selectedTabObject = item;
  }

  closeOutputWindow() {
      this.showOutput = false;
  }

  closeQuestionCard() {
      this.closeQuestion = true;
  }

  showQuestionCard() {
      this.closeQuestion = false;
  }

  showPracticeComponent() {
      console.log("showPracticeComponent");
      this.showPractice = false;
      // this.showLearn = true;
  }

}
